import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import {
    RecurringJournal,
    RecurringJournalRequest,
    RecurringJournalRun,
    RecurringRunResult,
} from '../interfaces/recurringJournal.interface';

const E = ENDPOINTS.RECURRING_JOURNAL;

export const RecurringJournalService = {
    list: async (institutionId: string): Promise<RecurringJournal[]> =>
        (await axios.get(E.LIST(institutionId))).data,
    get: async (id: string): Promise<RecurringJournal> => (await axios.get(E.BY_ID(id))).data,
    runs: async (id: string): Promise<RecurringJournalRun[]> => (await axios.get(E.RUNS(id))).data,
    create: async (req: RecurringJournalRequest): Promise<RecurringJournal> =>
        (await axios.post(E.BASE, req)).data,
    update: async (id: string, req: RecurringJournalRequest): Promise<RecurringJournal> =>
        (await axios.put(E.BY_ID(id), req)).data,
    runNow: async (id: string): Promise<RecurringRunResult> => (await axios.post(E.RUN_NOW(id))).data,
    skipNext: async (id: string): Promise<RecurringJournal> => (await axios.post(E.SKIP_NEXT(id))).data,
    pause: async (id: string): Promise<RecurringJournal> => (await axios.post(E.PAUSE(id))).data,
    resume: async (id: string): Promise<RecurringJournal> => (await axios.post(E.RESUME(id))).data,
    deactivate: async (id: string): Promise<RecurringJournal> => (await axios.post(E.DEACTIVATE(id))).data,
    remove: async (id: string): Promise<void> => {
        await axios.delete(E.BY_ID(id));
    },
    retryRun: async (runId: string): Promise<RecurringJournalRun> =>
        (await axios.post(E.RETRY_RUN(runId))).data,
};
